import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#4169e1" }, // royal blue
    secondary: { main: "#60a5fa" }, // light blue
    background: { default: "#f8fafc" }
  },
  typography: {
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    h2: { fontWeight: 900, letterSpacing: -2 },
    h5: { fontWeight: 600 }
  },
  shape: { borderRadius: 24 }
});
export default theme;
